import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs";
import { put } from "@rails/request.js";

// Connects to data-controller="sortable"
export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      animation: 350,
      ghostClass: "bg-gray-200",
      onEnd: this.onEnd.bind(this),   //after sort this callback will trigger
      handle: "[data-sortable-handle]", //on this element sortable handel or icon will be added
    });
  }

  disconnect() {
    this.sortable.destroy();
  }

  onEnd(event) {    
    const { item } = event;
    const url = item.dataset["sortableUrl"];
    
    if (!url) return
    
    // Get all sortable items (only those with data-sortable-url)
    const sortableItems = Array.from(this.element.children).filter(child => 
      child.dataset.sortableUrl && child.dataset.sortableUrl.trim() !== ''
    )
    
    // Find the new position based on sortable items only
    const newPosition = sortableItems.indexOf(item) + 1;

    // Determine the resource type from the URL to nest position correctly
    let resourceKey = 'position'; // default to top-level
    if (url.includes('/faqs/')) {
      resourceKey = 'faq';
    } else if (url.includes('/tickets/')) {
      resourceKey = 'ticket';
    }

    const body = resourceKey === 'position'
      ? { position: newPosition }
      : { [resourceKey]: { position: newPosition } };

    console.log('  Request body:', body);
    console.log('  Sending PUT request to:', url);

    put(url, {
      body: JSON.stringify(body),
      responseKind: "turbo-stream"
    });
  }
}
